module.exports = __webpack_public_path__ + "static/media/  (166).9ff5b2b1.jpg";